import { render, staticRenderFns } from "./PrintOrderList.vue?vue&type=template&id=71c239dc"
import script from "./PrintOrderList.vue?vue&type=script&lang=ts"
export * from "./PrintOrderList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports